import axios from './index'
import store from '@/store'
import { cleanParams } from '@/filters'
export const getUploadByPage = (params) => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/uploadRecord', {
    params: cleanParams({ ...params, companyId, teamId, field: 'createTime', order: 'desc' })
  })
}

export const addUpload = (params) => {
  const user = store.state.userInfo
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.post('/welldbCombine/uploadRecord', {
    moveToQuery: true,
    params: cleanParams({ ...params, companyId, teamId, createUserId: user.userId })
  })
}

export const deleteUpload = (id) => {
  return axios.delete('/welldbCombine/uploadRecord', {
    params: {
      id
    }
  })
}

export const getCloudFiles = (params) => {
  return axios.get('/welldbCombine/welldfsFiles', {
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
      field: 'createdAt',
      order: 'desc'
    }
  })
}
